import { Binder, BinderPropertyDescriptor, Component, View, ViewModel } from "binder";
import { ColumnFilter } from "../columnFilter/columnFilter";
import { ExTableViewModel } from "../exTable-viewModel";
import { ColumnSort } from "../sorting/columnSort";
import  { ColumnView } from "./column-view"
import { IColumnVisitor } from "./columnVisitor";

export abstract class ColumnViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ColumnView();
    }
    public getTypeId(): string {
        return "VM-B8F0DAFB-350E-441E-AEA1-2479C36171C0"
    }

    public set filter(v: ColumnFilter) { 
        this._filter = v; 
        if(v){
            Binder.createBinding(new BinderPropertyDescriptor(this,'isFiltered'),null,new BinderPropertyDescriptor(v,'isActive'))
        }
    } public get filter(): ColumnFilter { return this._filter;} private _filter: ColumnFilter;
    public set table(v: ExTableViewModel) { this._table = v; } public get table(): ExTableViewModel { return this._table;} private _table: ExTableViewModel;
    
    public set columnSort(v: ColumnSort) { 
        this._columnSort = v; 
        if(v){
            Binder.createBinding(new BinderPropertyDescriptor(this,'isSortAsc'),null,new BinderPropertyDescriptor(v,'ascending'))
            Binder.createBinding(new BinderPropertyDescriptor(this,'isSortDesc'),null,new BinderPropertyDescriptor(v,'descending'))
            Binder.createBinding(new BinderPropertyDescriptor(this,'isNoSort'),null,new BinderPropertyDescriptor(v,'noSort'))
        }
    } public get columnSort(): ColumnSort { return this._columnSort;} private _columnSort: ColumnSort;
        
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isSortAsc(v: boolean) { this._isSortAsc = v; } public get isSortAsc(): boolean { return this._isSortAsc;} private _isSortAsc: boolean;
    public set isSortDesc(v: boolean) { this._isSortDesc = v; } public get isSortDesc(): boolean { return this._isSortDesc;} private _isSortDesc: boolean;
    public set isNoSort(v: boolean) { this._isNoSort = v; } public get isNoSort(): boolean { return this._isNoSort;} private _isNoSort: boolean;
    public set isFiltered(v: boolean) { this._isFiltered = v; } public get isFiltered(): boolean { return this._isFiltered;} private _isFiltered: boolean;
    public set fieldname(v: string) { this._fieldname = v; } public get fieldname(): string { return this._fieldname;} private _fieldname: string;

    changeSortOrder() {
        this.columnSort.Change();
        this.table.columnSortChanged(this);
    }
    setNoSort(){
        this.columnSort.setNoSort();
    }

    filterChanged() {
        this.table.filterChanged();
    }

    abstract accept(visitor:IColumnVisitor,parameter:any):any;
}
